import {
  ingredientTypeGrain,
  ingredientTypeInclusion,
  ingredientTypeLiquid,
  SUBMIX_TYPE_PORRIDGE, SUBMIX_TYPE_SCALD, SUBMIX_TYPE_SOAKER
} from "../shared/Types";
import {getFieldValuesAsUniqueArray} from "../utils/ArrayUtils";

export function getSubmixComponentId(componentId, submixData) {
  return `${componentId}-${submixData.name}-${submixData.id}`
}

export function getSubmixIngredientComponents(submixData, submixComponentId) {
  const submixComponents = []
  submixData?.forEach(submix => {
    const submixComponent = {componentId: getSubmixComponentId(submixComponentId, submix), ingredientTypes: []}
    switch (submix.type) {
      case SUBMIX_TYPE_PORRIDGE: {
        submixComponent.ingredientTypes.push({
          type: ingredientTypeGrain,
          names: getFieldValuesAsUniqueArray(submix.grain, 'name')
        })
        submixComponent.ingredientTypes.push({
          type: ingredientTypeInclusion,
          names: getFieldValuesAsUniqueArray(submix.dry, 'name')
        })
        submixComponent.ingredientTypes.push({
          type: ingredientTypeLiquid,
          names: getFieldValuesAsUniqueArray(submix.liquid, 'name')
        })
        break
      }
      case SUBMIX_TYPE_SCALD: {
        submixComponent.ingredientTypes.push({
          type: ingredientTypeGrain,
          names: getFieldValuesAsUniqueArray(submix.flour, 'name')
        })
        submixComponent.ingredientTypes.push({
          type: ingredientTypeLiquid,
          names: getFieldValuesAsUniqueArray(submix.liquid, 'name')
        })
        break
      }
      case SUBMIX_TYPE_SOAKER: {
        submixComponent.ingredientTypes.push({
          type: ingredientTypeInclusion,
          names: getFieldValuesAsUniqueArray(submix.dry, 'name')
        })
        submixComponent.ingredientTypes.push({
          type: ingredientTypeLiquid,
          names: getFieldValuesAsUniqueArray(submix.liquid, 'name')
        })
        break
      }
      default:
    }
    submixComponents.push(submixComponent)
  })
  return submixComponents
}